<template>
  <div class="apartments">
    <div class="three desktopTitle">
      <h1>{{ categoryName }}</h1>
    </div>
    <div class="categoryTitleWrapper">
      <div class="gardeshgariTitle">{{ categoryName }}</div>
    </div>
    <div class="amlakFilterWrapper" :class="{ showShadow: showShadow }">
      <div class="wrapperContainer">
        <div class="searchBarWrapper">
          <div class="apartmentClassSearchBar">
            <filterBox
              @reload="load_post('first')"
              :selectedCategory="fillter.main_category"
            ></filterBox>
          </div>
          <div class="resBackBtn" @click="historyBackHandler">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"/></svg>
          </div>
        </div>
        <div class="filterTabsContainer" style="opacity: 0">
          <div class="filterTabList">
            <div
              class="filterTab"
              :class="{ active: fillter.main_category == 'all' }"
              @click="tabsFilterHandler('all')"
            >
              همه آگهی ها
            </div>
            <div
              v-if="fillter.main_category != 'request'"
              class="filterTab"
              :class="{ active: fillter.main_category == 'trade' }"
              @click="tabsFilterHandler('trade')"
            >
              آگهی فروش
            </div>
            <div
              v-if="fillter.main_category == 'request'"
              class="filterTab"
              :class="{ active: fillter.main_category == 'trade' }"
              @click="tabsFilterHandler('trade')"
            >
              آگهی خرید
            </div>
            <div
              v-if="fillter.category != 'land'"
              class="filterTab"
              :class="{ active: fillter.main_category == 'rent' }"
              @click="tabsFilterHandler('rent')"
            >
              آگهی اجاره
            </div>
          </div>
        </div>
        <div class="filterListContainer">
          <div class="categoryFilter">
            <el-select
              v-if="fillter.main_category != 'request'"
              placeholder="دسته بندی"
              v-model="fillter.main_category"
              @change="tabsFilterHandler"
            >
              <el-option :value="'all'" :label="'همه آگهی‌ ها'" />
              <el-option
                v-if="fillter.main_category != 'request'"
                :value="'trade'"
                :label="'آگهی فروش'"
              />
              <el-option
                v-if="fillter.main_category == 'request'"
                :value="'request'"
                :label="'آگهی خرید'"
              />
              <el-option
                v-if="fillter.category != 'land'"
                :value="'rent'"
                :label="'آگهی اجاره'"
              />
            </el-select>
            <el-select
              v-if="fillter.main_category == 'request'"
              placeholder="دسته بندی"
              v-model="fillter.request_type"
              @change="tabsRequestHandler"
            >
              <el-option :value="'all'" :label="'همه'" />
              <el-option
                :value="'buy'"
                :label="'متقاضی خرید'"
              />
              <el-option
                :value="'rent'"
                :label="'متقاضی اجاره'"
              />
            </el-select>
          </div>
          <div class="optionsFilter">
            <div class="swiperFilterList">
              <Swiper :slides-per-view="'auto'" :space-between="9">
                <SwiperSlide
                  v-if="
                    fillter.category != 'land' && fillter.category != 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="complate_mortage"
                    :class="{ filter_avtive : fillter.complate_mortage}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">رهن کامل</div>
                    <input
                      type="checkbox"
                      id="complate_mortage"
                      v-model="fillter.complate_mortage"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category == 'apartment' ||
                    fillter.category == 'Administrative' ||
                    fillter.category == 'villa_house' ||
                    fillter.category == 'commercial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="rent_mortage"
                    :class="{filter_avtive : fillter.rent_mortage}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">رهن و اجاره</div>
                    <input
                      type="checkbox"
                      id="rent_mortage"
                      v-model="fillter.rent_mortage"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide v-if="fillter.category == 'villa'">
                  <label
                    class="filterThumb"
                    for="dayli_rent"
                    :class="{filter_avtive : fillter.dayli_rent}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">اجاره روزانه</div>
                    <input
                      type="checkbox"
                      id="dayli_rent"
                      v-model="fillter.dayli_rent"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'land' && fillter.category != 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="convertable"
                    :class="{filter_avtive : fillter.convertable}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">قابل تبدیل</div>
                    <input
                      type="checkbox"
                      id="convertable"
                      v-model="fillter.convertable"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'Administrative' &&
                    fillter.category != 'villa_house' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'industrial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'villa'
                  "
                >
                  <label
                    class="filterThumb"
                    for="single_unit"
                    :class="{filter_avtive : fillter.single_unit}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">تک واحدی</div>
                    <input
                      type="checkbox"
                      id="single_unit"
                      v-model="fillter.single_unit"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="two_room"
                    :class="{filter_avtive : fillter.two_room}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">دو اتاق</div>
                    <input
                      type="checkbox"
                      id="two_room"
                      v-model="fillter.two_room"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="three_room"
                    :class="{filter_avtive : fillter.three_room}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">سه اتاق</div>
                    <input
                      type="checkbox"
                      id="three_room"
                      v-model="fillter.three_room"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'Administrative' &&
                    fillter.category != 'villa_house' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'industrial' &&
                    fillter.category != 'land' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'villa'
                  "
                >
                  <label
                    class="filterThumb"
                    for="pent"
                    :class="{filter_avtive : fillter.pent}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">پنت هاوس</div>
                    <input
                      type="checkbox"
                      id="pent"
                      v-model="fillter.pent"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'Administrative' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="doblex"
                    :class="{filter_avtive : fillter.doblex}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">دوبلکس</div>
                    <input
                      type="checkbox"
                      id="doblex"
                      v-model="fillter.doblex"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'Administrative'">
                  <label
                    class="filterThumb"
                    for="iswc"
                    :class="{filter_avtive : fillter.iswc}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">سرویس بهداشتی</div>
                    <input
                      type="checkbox"
                      id="iswc"
                      v-model="fillter.iswc"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'villa'">
                  <label
                    class="filterThumb"
                    for="ispool"
                    :class="{filter_avtive : fillter.ispool}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">استخر</div>
                    <input
                      type="checkbox"
                      id="ispool"
                      v-model="fillter.ispool"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'villa'">
                  <label
                    class="filterThumb"
                    for="isjacozi"
                    :class="{filter_avtive : fillter.isjacozi}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">جکوزی</div>
                    <input
                      type="checkbox"
                      id="isjacozi"
                      v-model="fillter.isjacozi"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide
                  v-if="
                    fillter.category != 'villa_house' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="elevator"
                    :class="{filter_avtive : fillter.elevator}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">آسانسور</div>
                    <input
                      type="checkbox"
                      id="elevator"
                      v-model="fillter.elevator"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide
                  v-if="
                    fillter.category != 'garden' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="doc_ismelk"
                    :class="{filter_avtive : fillter.doc_ismelk}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">سند ملک</div>
                    <input
                      type="checkbox"
                      id="doc_ismelk"
                      v-model="fillter.doc_ismelk"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'villa_house' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="les_sad"
                    :class="{filter_avtive : fillter.les_sad}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">کمتر از 100 متر</div>
                    <input
                      type="checkbox"
                      id="les_sad"
                      v-model="fillter.les_sad"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'villa_house' &&
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="more_sad"
                    :class="{filter_avtive : fillter.more_sad}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">بیشتر از 100 متر</div>
                    <input
                      type="checkbox"
                      id="more_sad"
                      v-model="fillter.more_sad"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="parking"
                    :class="{filter_avtive : fillter.parking}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">پارکینگ</div>
                    <input
                      type="checkbox"
                      id="parking"
                      v-model="fillter.parking"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category != 'commercial' &&
                    fillter.category != 'garden' &&
                    fillter.category != 'land' &&
                    fillter.category != 'industrial'
                  "
                >
                  <label
                    class="filterThumb"
                    for="storage"
                    :class="{filter_avtive : fillter.storage}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">انباری</div>
                    <input
                      type="checkbox"
                      id="storage"
                      v-model="fillter.storage"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'commercial'">
                  <label
                    class="filterThumb"
                    for="isglass"
                    :class="{filter_avtive : fillter.isglass}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">شیشه سکوریت</div>
                    <input
                      type="checkbox"
                      id="isglass"
                      v-model="fillter.isglass"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'commercial'">
                  <label
                    class="filterThumb"
                    for="isremotedoor"
                    :class="{filter_avtive : fillter.isremotedoor}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">کرکره برقی</div>
                    <input
                      type="checkbox"
                      id="isremotedoor"
                      v-model="fillter.isremotedoor"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide
                  v-if="
                    fillter.category == 'commercial' ||
                    fillter.category == 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="iswater"
                    :class="{filter_avtive : fillter.iswater}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">آب</div>
                    <input
                      type="checkbox"
                      id="iswater"
                      v-model="fillter.iswater"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category == 'commercial' ||
                    fillter.category == 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="iselectricity"
                    :class="{filter_avtive : fillter.iselectricity}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">برق</div>
                    <input
                      type="checkbox"
                      id="iselectricity"
                      v-model="fillter.iselectricity"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category == 'commercial' ||
                    fillter.category == 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="isgas"
                    :class="{filter_avtive : fillter.isgas}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">گاز</div>
                    <input
                      type="checkbox"
                      id="isgas"
                      v-model="fillter.isgas"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide v-if="fillter.category == 'commercial'">
                  <label
                    class="filterThumb"
                    for="isceramic"
                    :class="{filter_avtive : fillter.isceramic}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">کف سرامیک</div>
                    <input
                      type="checkbox"
                      id="isceramic"
                      v-model="fillter.isceramic"
                    />
                  </label>
                </SwiperSlide>

                <SwiperSlide v-if="fillter.category == 'commercial'">
                  <label
                    class="filterThumb"
                    for="isbalcony"
                    :class="{filter_avtive : fillter.isbalcony}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">بالکن</div>
                    <input
                      type="checkbox"
                      id="isbalcony"
                      v-model="fillter.isbalcony"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.main_category == 'request' &&
                    fillter.request_type == 'buy'
                  "
                >
                  <label
                    class="filterThumb"
                    for="rebuild"
                    :class="{filter_avtive : fillter.rebuild}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">بازسازی شده</div>
                    <input
                      type="checkbox"
                      id="rebuild"
                      v-model="fillter.rebuild"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category == 'land' || fillter.category == 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="inbaft"
                    :class="{filter_avtive : fillter.inbaft}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">داخل بافت</div>
                    <input
                      type="checkbox"
                      id="inbaft"
                      v-model="fillter.inbaft"
                    />
                  </label>
                </SwiperSlide>
                <SwiperSlide
                  v-if="
                    fillter.category == 'land' || fillter.category == 'garden'
                  "
                >
                  <label
                    class="filterThumb"
                    for="outbaft"
                    :class="{filter_avtive : fillter.outbaft}"
                    @click="set_filter()"
                  >
                    <div class="filterTit">خارج بافت</div>
                    <input
                      type="checkbox"
                      id="outbaft"
                      v-model="fillter.outbaft"
                    />
                  </label>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div class="sortFilter">
            <el-select
              v-model="fillter.order_by"
              @change="set_filter()"
              placeholder="مرتب سازی"
            >
              <el-option value="newest" :label="'جدیدترین'" />
              <el-option
                v-if="fillter.main_category != 'request'"
                value="top_view"
                :label="'محبوب‌ترین'"
              />
              <el-option
                v-if="fillter.main_category == 'request'"
                value="top_view"
                :label="'فوری'"
              />
              <el-option value="oldest" :label="'قدیمی‌ترین'" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="showMapBtn">
      <router-link to="/map-house?main_cat=all&cat=all" class="mapBtn">
        <div class="btnIcon">
          <VsxIcon iconName="Map1" :size="26" color="#fff" type="linear" />
        </div>
        <div class="btnTitle">نمایش آگهی‌ها روی نقشه</div>
      </router-link>
    </div>
    <div
      style="margin-top: 30px"
      v-if="post_list.length == 0 && isLoading"
      class="apartmentsListContainer"
    >
      <Skeletor
        v-for="(v, i) in 12"
        :key="i"
        class="ChildShowTabToUserCustomer sliderBottm"
        height="308"
        style="
          background: rgb(163, 219, 213);
          margin-bottom: 2rem;
          border-radius: 10px;
        "
      />
    </div>

    <div v-show="post_list.length > 0 && !isLoading">
      <div
        v-for="(p, i) in post_list"
        :key="i"
        :style="!p.tabligh.img ? 'margin-top:0' : ''"
        class="propertyListsContainer"
      >
        <div
          v-if="p.tabligh.img"
          class="listAdsBanner"
          @click="showAdsLinkHandler(p.tabligh.link)"
        >
          <img
            v-if="p.tabligh.img"
            :src="p.tabligh.img"
            class="mobileBanner"
            alt=""
          />
          <img
            v-if="p.tabligh.img2"
            :src="p.tabligh.img2"
            class="desktopBanner"
            alt=""
          />
        </div>

        <div
          class="propertyThumb"
          v-for="(v, i) in p.list"
          :key="i"
          @click="showPost(v)"
        >
          <div class="propertyPic">
            <div class="propertyNums">
              <div class="likesNum">
                <div class="numsICON">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                    />
                  </svg>
                </div>
                <div class="numNumber">{{ v.likes }}</div>
              </div>
              <div class="commentsNum">
                <div class="numsICON">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                    />
                  </svg>
                </div>
                <div class="numNumber">{{ v.comments_count }}</div>
              </div>
            </div>
            <img :src="v.avatar" :alt="v.content" @error="handleImageError" />
          </div>
          <div class="propertyContent">
            <div class="contanteHeader">
              <div class="propertyCategory">
                {{ v.main_category }}
                <span v-if="v.main_category_en == 'request'">{{
                  v.request_type
                }}</span>
                - {{ v.category }}
              </div>
              <div class="propertyUpload">
                <div class="propertyUploadIcon">
                  <VsxIcon
                    iconName="Calendar"
                    :size="14"
                    color="#0096c7"
                    type="linear"
                  />
                </div>
                <div class="propertyUploadTitle">{{ v.created_fa }}</div>
              </div>
            </div>
            <div class="contentMain">
              <div class="propertyTitle">
                {{
                  v.content.length > 34
                    ? v.content.slice(0, 34) + "..."
                    : v.content
                }}
              </div>
              <div class="propertyLocation">
                <div class="locationIcon">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div v-if="v.main_category_en != 'request'" class="locationTitle">
                  {{ v.address }}
                </div>
                <div v-else-if="v.main_category_en == 'request' && v.districts && v.districts.length > 0" class="locationTitle">
                  <span v-for="(d,j) in v.districts" :key="j">{{ d }} - </span>
                </div>
              </div>
              <div class="contentFeaturesWrapper">
                <div
                  v-if="v.feature && v.feature.includes('fast')"
                  class="featuresThumb fast"
                >
                  <i class="fa-solid fa-bolt"></i>
                  <span>فوری</span>
                </div>
                <div
                  v-if="v.feature && v.feature.includes('exchangeable')"
                  class="featuresThumb exchange"
                >
                  <i class="fa-solid fa-rotate"></i>
                  <span>قابل معاوضه</span>
                </div>
                <div
                  v-if="
                    v.feature &&
                    (v.feature.includes('single') ||
                      v.feature.includes('student'))
                  "
                  class="featuresThumb single"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                    />
                    <path
                      d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                    />
                    <path
                      d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                    />
                  </svg>
                  <span>دانشجو/مجرد</span>
                </div>
              </div>
              <div class="contentPriceWrapper">
                <div
                  class="priceWrapper tradePrice"
                  v-if="
                    v.main_category_en != 'rent' &&
                    !(
                      v.main_category_en == 'request' &&
                      v.request_type_en == 'rent'
                    )
                  "
                >
                  <div class="pricecTitle" v-if="v.main_category_en == 'trade'">
                    قیمت فروش:
                  </div>
                  <div
                    class="pricecTitle"
                    v-if="v.main_category_en == 'request'"
                  >
                    قیمت خرید:
                  </div>
                  <div v-if="v.main_category_en != 'request'" class="priceValue">{{ v.total_price }}</div>
                  <div v-if="v.main_category_en == 'request'" class="priceValue">
                    <span>از {{ v.total_price }}</span>
                    <span>تا {{ v.total_price_max }}</span>
                  </div>
                </div>
                <div
                  class="priceWrapper"
                  v-if="
                    v.main_category_en == 'rent' ||
                    (v.main_category_en == 'request' &&
                      v.request_type_en == 'rent')
                  "
                >
                  <div class="pricecTitle">مبلغ رهن:</div>
                  <div v-if="v.main_category_en != 'request'" class="priceValue">{{ v.mortgage_price }}</div>
                  <div v-if="v.main_category_en == 'request'" class="priceValue">{{ v.mortgage_price }} تا {{ v.mortgage_price_max }}</div>
                </div>
                <div
                  class="priceWrapper"
                  v-if="
                    v.main_category_en == 'rent' ||
                    (v.main_category_en == 'request' &&
                      v.request_type_en == 'rent')
                  "
                >
                  <div class="pricecTitle">مبلغ اجاره:</div>
                  <div v-if="v.main_category_en != 'request'" class="priceValue">{{ v.rent_price }}</div>
                  <div v-if="v.main_category_en == 'request'" class="priceValue">{{ v.rent_price }} تا {{ v.rent_price_max }}</div>
                </div>
              </div>
              <div class="realStateInfoWrapper">
                <div v-if="v.user_role == 'builder' || v.user_role == 'customer'" class="realStateInfo">
                  <div class="infoPic">
                    <img :src="v.user_avatar" alt="" />
                  </div>
                  <div class="infoTitle">
                    {{ v.nickname }}
                  </div>
                </div>
                <div v-else class="realStateInfo">
                  <div class="infoPic">
                    <img :src="v.branch_avatar" alt="" />
                  </div>
                  <div class="infoTitle">
                    {{ v.branch_title }}
                  </div>
                </div>
                <div class="realStateBtn">
                  <div class="followBtn">
                    <div class="btnTitle">جزئیات</div>
                    <div class="btnIcon">
                      <i class="fas fa-arrow-left"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div ref="loadMoreTrigger" class="trigger"></div>
    </div>
    <div
      v-if="post_list.length == 0 && !isLoading"
      class="justify-center align-center mt-4"
      style="text-align: center; height: 90%"
    >
      <img
        :src="publicPath + 'img/notfound.png'"
        alt="Alt text"
        width="320"
        height="280"
      />
      <p class="noResultContent">موردی برای نمایش وجود ندارد!</p>
    </div>
  </div>
</template>

<script>
import filterBox from "@/components/filterBox/filterBox.vue";
import { Skeletor } from "vue-skeletor";
import "vue3-carousel/carousel.css";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";

export default {
  name: "CategoryPage",
  components: {
    filterBox,
    Skeletor,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      carouselConfig1: {
        itemsToShow: 0,
        wrapAround: false,
        snapAlign: "right",
        dir: "rtl",
      },
      loadMoreTrigger: null,
      fillter: {
        main_category: 'all',
        request_type: "all",
        category: "all",
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        fast: false,
        request: false,
        exchangeable:false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        student: false,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: 12,
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
        complate_mortage: false,
        rent_mortage: false,
        dayli_rent: false,
        convertable: false,
        iswc: false,
        ispool: false,
        isjacozi: false,
        isglass: false,
        isremotedoor: false,
        iswater: false,
        iselectricity: false,
        isgas: false,
        isceramic: false,
        isbalcony: false,
        rebuild: false,
        inbaft: false,
        outbaft: false,
      },
      front_show: {
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        district_list: [],
      },
      post_list: [],
      showShadow: false,
    };
  },
  computed: {
    categoryName() {
      const c = this.fillter.category;
      if (this.fillter.main_category == "trade") return "فروش";
      if (this.fillter.main_category == "rent") return "اجاره";
      if (this.fillter.main_category == "request") return "متقاضی";
      else if (this.fillter.fast) return "آگهی فوری";
      else if (this.fillter.exchangeable) return "معاوضه";
      else if (this.fillter.student) return "دانشجو/مجرد";
      else {
        switch (c) {
          case "apartment":
            return "آپارتمان";
          case "Administrative":
            return "اداری";
          case "villa_house":
            return "خانه حیاط دار";
          case "villa":
            return "ویلا";
          case "commercial":
            return "تجاری";
          case "industrial":
            return "صنعتی";
          case "garden":
            return "باغ";
          case "land":
            return "زمین";
          default:
            return "همه آگهی‌ها";
        }
      }
    }
  },
  methods: {
    showAdsLinkHandler(link) {
      if (link) {
        window.open(link, "_blank");
      }
    },
    showPost(ob) {
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", ob);
      this.$router.push(`/details/${ob.id}`);
    },
    calculateItemsToShow() {
      const width = window.innerWidth;
      if (width > 1200) return 11.6;
      if (width > 1000) return 8.5;
      return 6.5;
    },
    updateCarouselConfig1() {
      const itemsToShow = this.calculateItemsToShow();
      this.carouselConfig1.itemsToShow = itemsToShow;
    },
    set_filter() {
      setTimeout(() => {
        localStorage.removeItem("post_fillter");
        this.$store.commit("post_fillter_set", [this.fillter, this.front_show]);
        this.load_post("first");
      }, 1000);
    },
    tabsFilterHandler(category) {
      this.$store.dispatch("checkPostFillter");
      if (this.$store.getters.post_fillter.length > 0) {
        localStorage.removeItem("post_fillter");
        this.$store.getters.post_fillter[0].main_category = category;
        this.$store.commit("post_fillter_set", [
          this.$store.getters.post_fillter[0],
          this.$store.getters.post_fillter[1],
        ]);
      } else {
        this.fillter.main_category = category;
      }
      this.load_post("first");
    },
    tabsRequestHandler(category) {
      this.$store.dispatch("checkPostFillter");
      if (this.$store.getters.post_fillter.length > 0) {
        localStorage.removeItem("post_fillter");
        this.$store.getters.post_fillter[0].request_type = category;
        this.$store.commit("post_fillter_set", [
          this.$store.getters.post_fillter[0],
          this.$store.getters.post_fillter[1],
        ]);
      } else {
        this.fillter.request_type = category;
      }
      this.load_post("first");
    },
    load_post(param) {
      this.$store.dispatch("checkPostFillter");
      console.log("post_fillter_set", this.$store.getters.post_fillter);
      if (this.$store.getters.post_fillter.length > 0) {
        this.fillter = this.$store.getters.post_fillter[0];
        const newQuery = { ...this.$route.query };
        delete newQuery.feature;
        delete newQuery.cat;
        this.$router.replace({ query: newQuery });
      } else {
        if (this.$route.query.cat || this.$route.query.feature) {
          if (this.$route.query.cat)
            this.fillter.category = this.$route.query.cat;
          if (this.$route.query.feature) {
            localStorage.removeItem("post_fillter");
            if (this.$route.query.feature == "request")
              this.fillter.main_category = "request";
            if (this.$route.query.feature == "fast") this.fillter.fast = true;
            if (this.$route.query.feature == "exchangeable")
              this.fillter.exchangeable = true;
            if (this.$route.query.feature == "student")
              this.fillter.student = true;

            setTimeout(() => {
              this.$store.commit("post_fillter_set", [
                this.fillter,
                this.front_show,
              ]);
            }, 1000);
          }
        }
      }

      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }
      if (this.$store.state.auth.loggedIn)
        this.fillter.user_id = this.$store.state.auth.uid;

      this.fillter.hastabligh = true;

      axios
        .post(this.$store.getters.baseUrl + "/public-post-list", this.fillter)
        .then((r) => {
          if (r.data.result == 0) {
            this.post_list = [];
            if (param != "first") {
              this.fillter.page -= 1;
            }
          } else {
            this.post_list = this.post_list.concat(r.data.data.list);
            if (r.data.data.total_page == this.fillter.page) {
              this.loadmore = false;
            }
          }
          this.isLoading = false;
          this.loadmore_loading = false;
        });
    },
    handleImageError(event) {
      event.target.src = "../assets/img/noimage.jpg";
    },

    historyBackHandler() {
      history.back()
    },
    handleWindowScroll() {
      let windowSize = window.innerWidth;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (windowSize > 1000) {
        if (scrollTop + windowHeight + 686.6 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            this.load_post();
          }
        }
      } else {
        if (scrollTop + windowHeight + 100 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            this.load_post();
          }
        }
      }
      if (window.innerWidth < 700 && window.scrollY > 86) {
        this.showShadow = true;
      } else {
        this.showShadow = false;
      }
    },
  },
  mounted() {
    console.log("this.keepAliveCategory")
    this.load_post("first");
    // this.categoryNameHandler();
    this.updateCarouselConfig1();
    window.addEventListener("resize", this.updateCarouselConfig1);
    window.addEventListener("scroll", this.handleWindowScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
};
</script>

<style lang="scss" scoped>
.filter_avtive {
  background: #0096c7 !important;
  color: #f5f5f5 !important;
}
.ShowTabToUserCustomer {
  width: 100% !important;
}

.topNav__searchbar_wrapper {
  position: relative !important;
  width: 100% !important;
  height: 50px;
  background: #fff;
  border-radius: 30px !important;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);

  .searchbar_input {
    box-shadow: none !important;
  }
}

.filterbutton_wrapper {
  position: absolute;
  left: 20px;
  top: 7px;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.filterTabsContainer {
  width: 100%;
  margin: 16px 0 -6px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  display: none;

  .filterTabList {
    display: flex;
    align-items: center;
    gap: 1.25rem;

    .filterTab {
      position: relative;
      font-size: 16px;
      min-height: 100%;
      cursor: pointer;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -13.5px;
        display: none;
        width: 100%;
        height: 2px;
        background: #0096c7;
      }

      &.active {
        color: #0096c7;

        &::after {
          display: block;
        }
      }
    }
  }
}

.swiperFilterList {
  display: block;
  width: 100%;

  .swiper {
    padding: 1px 0;
    .swiper-slide {
      width: auto;
    }
  }

  .filterThumb {
    height: 42px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f9fafb;
    border-radius: 12px;
    border: 1px solid rgb(209, 213, 219);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;
    font-size: 0.9rem;
    position: relative;
    transition: all 0.15s;

    &:active {
      transform: scale(0.95);
    }

    &.filter_avtive {
      border: 1px solid #0096c7;
      background: #0096c7;
      color: #fff;
    }

    .filterTit {
      position: relative;
      z-index: 1;
    }

    input {
      position: absolute;
      inset: 0;
      z-index: 2;
      opacity: 0;
      cursor: pointer;
    }
  }
}

.filterListContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;

  .categoryFilter {
    width: 152px;
    margin-right: 6px;
    margin-left: 22px;

    .el-select {
      :deep(.el-select__wrapper) {
        width: 124px;
        height: 42px;
        border-radius: 0.375rem;
        border: 1px solid rgb(209, 213, 219);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        background: #f9fafb !important;
      }
    }
  }

  .optionsFilter {
    width: calc(100% - 304px);
  }

  .sortFilter {
    width: 152px;
    margin-left: 6px;
    margin-right: 22px;

    .el-select {
      display: flex;
      justify-content: left;
      :deep(.el-select__wrapper) {
        width: 124px;
        height: 42px;
        border-radius: 0.375rem;
        border: 1px solid rgb(209, 213, 219);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        background: #f9fafb !important;
      }
    }
  }
}

.showMapBtn {
  position: fixed;
  bottom: 32px;
  left: 0;
  right: 0;
  z-index: 998;

  .mapBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 20px;
    height: 48px;
    background: #0096c7;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    width: fit-content;
    margin: 0 auto;
    border-radius: 24px;
    border: 1px solid #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  }
}

@media (min-width: 577px) {
  .filterTitle {
    display: none;
  }
}

@media (max-width: 600px) {
  .filterListContainer {
    flex-wrap: wrap;

    .categoryFilter {
      width: calc(50% - 8px);
      order: 2;
      margin: 0;

      .el-select {
        display: flex;
        justify-content: center;
        :deep(.el-select__wrapper) {
          width: 100%;
          height: 38px;
        }
      }
    }

    .optionsFilter {
      width: 100%;
      order: 1;
      margin-bottom: 16px;

      .swiper {
        padding: 2px 1px;
      }

      .filterThumb {
        height: 32px;
      }
    }

    .sortFilter {
      width: calc(50% - 8px);
      order: 3;
      margin: 0;

      .el-select {
        display: flex;
        justify-content: center;
        :deep(.el-select__wrapper) {
          width: 100%;
          height: 38px;
        }
      }
    }
  }
}

@media (max-width: 577px) {
  .filterTitle {
    display: block;

    .filterTitleContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 90%;
      margin: 0 auto;
      padding-top: 16px;

      h4 {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.25rem;
        font-weight: 500;
      }

      .closeFilterBtn {
        position: relative;
        width: 32px;
        height: 32px;
        background: #0096c7;
        border-radius: 6px;

        .filterBtnBar {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 86%;
          height: 3px;
          background: #fff;
          border-radius: 6px;

          &:first-of-type {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &:last-of-type {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }
  }
}

.parent {
  display: flex;
  flex-wrap: wrap;
}

.parent > :first-child {
  flex: 0 0 100%;
}

.parent > :not(:first-child) {
  flex: 0 0 calc(25% - 10px); /* 4 آیتم در هر ردیف با فاصله 10px */
  margin: 5px; /* ایجاد فاصله بین آیتم‌ها */
  box-sizing: border-box;
}

.dark {
  .categoryTitleWrapper {
    .gardeshgariTitle {
      color: #fff !important;
    }
  }
}

.categoryTitleWrapper {
  width: 100%;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 24px;

  .gardeshgariTitle {
    width: 100% !important;

    &::after,
    &::before {
      width: 90px !important;
    }
  }

  .categoryTitle {
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-family: "iranyekanB", sans-serif;
    position: relative;
    padding-bottom: 15px;

    &::before {
      margin: auto;
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      bottom: 2px;
      height: 1px;
      width: 95%;
      max-width: 255px;
      background-color: #333;
    }

    &::after {
      margin: auto;
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      height: 5px;
      width: 100px;
      background-color: #000000;
      border-radius: 5px;
    }
  }
}

.dark {
  .categoryTitleWrapper {
    .categoryTitle {
      color: #fff;

      &::before {
        background: #ccc;
      }

      &::after {
        background: #fff;
      }
    }
  }
}

.listAdsBanner {
  cursor: pointer;
}

@media (min-width: 700px) {
  .categoryTitleWrapper {
    display: none;
  }
}

@media (max-width: 700px) {
  .three.desktopTitle {
    display: none;
  }
}

@media (min-width: 1000px) {
  .mobileBanner {
    display: none !important;
  }
}

@media (max-width: 1000px) {
  .desktopBanner {
    display: none !important;
  }
}
.noResultContent {
  text-align: center;
  font-size: 0.95rem;
}

.locationTitle {
  font-size: 0.75rem;
  line-height: 1.5;
}
</style>
